import template from './image-model.vhtml';
import './image-model.scss';

export default {
  template,
  props: {
    imageSrc: '',
    imageAlt: '',
  },
  data: () => ({
    showModel: false,
  }),
  methods: {
    openModel: function () {
      this.showModel = true;
    },
    closeModel: function () {
      this.showModel = false;
    },
  },
};



// WEBPACK FOOTER //
// ./assets/_js/components/image-model/image-model.js